"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const login_1 = __importDefault(require("../actions/signin/login"));
const useStyles = makeStyles_1.default((theme) => ({
    paper: {
        color: theme.colors.loginRegister.textColor,
        backgroundColor: theme.colors.loginRegister.backgroundColor,
        textAlign: "center",
        padding: 20
    },
    icon: {
        width: 80,
        height: 80
    },
    button: {
        color: theme.colors.loginRegister.buttonTextColor,
        backgroundColor: theme.colors.loginRegister.buttonBackgroundColor,
        "&:hover": {
            backgroundColor: theme.colors.loginRegister.buttonBackgroundColor,
        }
    }
}));
function Login() {
    const classes = useStyles();
    const dispatch = react_redux_1.useDispatch();
    return (react_1.default.createElement(Paper_1.default, { className: classes.paper },
        react_1.default.createElement("img", { src: "oc-logo2.svg", className: classes.icon }),
        react_1.default.createElement("h1", null, "OpenChat"),
        react_1.default.createElement("p", null, "Welcome to OpenChat!"),
        react_1.default.createElement("p", null, "Before continuing you must sign-in to the Internet Computer."),
        react_1.default.createElement(Button_1.default, { size: "large", variant: "contained", className: classes.button, onClick: _ => dispatch(login_1.default()) }, "Sign-in")));
}
exports.default = Login;
